import script from "./news-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./news-list.vue?vue&type=script&setup=true&lang=ts"

import "./news-list.vue?vue&type=style&index=0&id=292b9bd6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292b9bd6"]])

export default __exports__